import { useState, useEffect } from 'react'
import { Icon } from "@iconify/react"
import { addTripReviewAPI, getCompanyDetailsAPI, getReservationAPI } from "../utils/api"
// import {Logo_Xtreim} from "../../public/"

export default function FeedbackPage() {
  const [rating, setRating] = useState(0)
  const [hover, setHover] = useState(0)
  const [Company, setCompany] = useState({})
  const [feedback, setFeedback] = useState('')
  const [tripId, setTripId] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [tripDetails, setTripDetails] = useState(null)

  useEffect(() => {
    // Get tripId from URL parameters using URLSearchParams
    const searchParams = new URLSearchParams(window.location.search)
    const tripIdFromParams = searchParams.get('tripId')
    if (tripIdFromParams) {
      setTripId(tripIdFromParams)
    }    
  }, [])

  useEffect(() => {
    if (tripId) {
      getCompanyDetailsAPI(tripId)
        .then((response) => {
          setCompany(response.data)
        })
        .catch((error) => {
          console.error('Error fetching company details:', error)
        })

        getReservationAPI(tripId, true)
          .then((response) => {
            // You can handle the reservation data if needed
            setTripDetails(response.data.trip)
          })
          .catch((error) => {
            console.error('Error fetching reservation details:', error)
          })
    }}
  , [tripId])

 const handleSubmit = async (e) => {
  e.preventDefault()
  setIsSubmitting(true)

  try {
    const customer = tripDetails?.customer?._id || {}
    const data = { rating, feedback, tripId, customer}
    await addTripReviewAPI(data)

    if (rating === 5 && Company?.googleReview) {
      window.location.href = Company.googleReview
    } else {
      window.location.href = '/links/thankyou'
    }
  } catch (error) {
    console.error('Error submitting feedback:', error)
  } finally {
    setIsSubmitting(false)
  }
}


  const getRatingText = () => {
    switch (rating) {
      case 1: return "Poor"
      case 2: return "Fair"
      case 3: return "Good"
      case 4: return "Very Good"
      case 5: return "Excellent"
      default: return ""
    }
  }

  const getRatingColor = () => {
    if (rating <= 2) return "text-red-500"
    if (rating === 3) return "text-yellow-500"
    if (rating === 4) return "text-blue-500"
    if (rating === 5) return "text-green-500"
    return "text-gray-500"
  }

 return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex flex-col items-center justify-center p-4">
     <header className="absolute top-4 left-4 flex items-center space-x-3 z-10">
  {Company?.logo && (
    <img
      src={Company.logo}
      alt="Company Logo"
      className="h-12 w-12 rounded-full object-cover"
    />
  )}
  <span className="text-base font-semibold text-gray-700">{Company?.name}</span>
</header>

      <div className="max-w-lg w-full">
        {/* Header Section */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-full mb-4">
            <Icon icon="material-symbols:feedback" className="text-3xl text-indigo-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">How was your trip?</h1>
          <p className="text-gray-600">Your feedback helps us improve our service</p>
          {/* {tripId && (
            <div className="mt-3 inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
              <Icon icon="material-symbols:trip" className="mr-1" />
              Trip #{tripId}
            </div>
          )} */}
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          <div className="p-8">
            {/* Rating Section */}
            <div className="text-center mb-8">
              <h2 className="text-lg font-semibold text-gray-800 mb-4">Rate your experience</h2>
              
              <div className="flex justify-center items-center space-x-2 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    className="transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 rounded-full p-1"
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHover(star)}
                    onMouseLeave={() => setHover(0)}
                  >
                    <Icon
                      icon="fa:star"
                      className="text-4xl transition-colors duration-200"
                      style={{ 
                        color: star <= (hover || rating) ? "#fbbf24" : "#e5e7eb",
                        filter: star <= (hover || rating) ? "drop-shadow(0 2px 4px rgba(251, 191, 36, 0.3))" : "none"
                      }}
                    />
                  </button>
                ))}
              </div>

              {rating > 0 && (
                <div className="animate-fade-in">
                  <span className={`text-lg font-semibold ${getRatingColor()}`}>
                    {getRatingText()}
                  </span>
                  <div className="flex justify-center mt-2">
                    {[...Array(rating)].map((_, i) => (
                      <Icon key={i} icon="fa:star" className="text-yellow-400 text-sm mx-0.5" />
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Feedback Form */}
            <form onSubmit={handleSubmit} className="space-y-6">
              {rating > 0 && rating < 5 && (
                <div className="animate-slide-down">
                  <label htmlFor="feedback" className="block text-sm font-semibold text-gray-700 mb-3">
                    <Icon icon="material-symbols:edit-note" className="inline mr-2" />
                    Tell us how we can improve
                  </label>
                  <textarea
                    id="feedback"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200 resize-none"
                    rows="4"
                    placeholder="Share your thoughts on how we can make your next trip even better..."
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                  />
                  <div className="text-xs text-gray-500 mt-2">
                    {feedback.length}/500 characters
                  </div>
                </div>
              )}

              {rating === 5 && (
                <div className="animate-slide-down bg-green-50 border border-green-200 rounded-xl p-4">
                  <div className="flex items-center">
                    <Icon icon="material-symbols:celebration" className="text-green-500 text-xl mr-3" />
                    <div>
                      <h3 className="text-green-800 font-semibold">Fantastic!</h3>
                      <p className="text-green-700 text-sm">We'd love if you could share your experience on Google!</p>
                    </div>
                  </div>
                </div>
              )}

              {rating > 0 && (
                <button
                  type="submit"
                  disabled={isSubmitting || !tripId}
                  className="w-full bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-200 transform hover:scale-[1.02] disabled:hover:scale-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 shadow-lg disabled:shadow-none"
                >
                  {isSubmitting ? (
                    <div className="flex items-center justify-center">
                      <Icon icon="eos-icons:loading" className="animate-spin mr-2" />
                      Submitting...
                    </div>
                  ) : (
                    <div className="flex items-center justify-center">
                      <Icon 
                        icon={rating === 5 ? "material-symbols:open-in-new" : "material-symbols:send"} 
                        className="mr-2" 
                      />
                      {rating === 5 ? 'Leave a Google Review' : 'Submit Feedback'}
                    </div>
                  )}
                </button>
              )}
            </form>
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-8 py-4 border-t border-gray-100">
            <div className="flex items-center justify-center text-sm text-gray-600">
              <Icon icon="material-symbols:lock" className="mr-2" />
              Your feedback is confidential and helps us serve you better
            </div>
          </div>
        </div>

        {/* Bottom Text */}
        <div className="text-center mt-6">
          <p className="text-sm text-gray-500">
            Thank you for choosing our service
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes slide-down {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }
        
        .animate-slide-down {
          animation: slide-down 0.4s ease-out;
        }
      `}</style>
    </div>
  )
}
